import type { AssetListItem } from '@cartwhl/common/api/getAssets';

import BatchStackedThumbnailShell from '../../shared/BatchStackedThumbnailShell';
import AssetLibraryThumbnail from './AssetLibraryThumbnail';

export interface AssetLibraryStackedThumbnailProps {
  asset: AssetListItem;
  isHovered?: boolean;
  autoPlayVideo?: boolean;
  onLoadError?: () => void;
}

export default function AssetLibraryStackedThumbnail({
  asset,
  isHovered = false,
  autoPlayVideo = false,
  onLoadError,
}: AssetLibraryStackedThumbnailProps) {
  const backLayer = (
    <AssetLibraryThumbnail
      assetType={asset.assetType}
      thumbnailURL={asset.thumbnailURL}
    />
  );

  return (
    <BatchStackedThumbnailShell
      backLayer={backLayer}
      frontLayer={
        <AssetLibraryThumbnail
          assetType={asset.assetType}
          thumbnailURL={asset.thumbnailURL}
          isHovered={isHovered}
          autoPlayVideo={autoPlayVideo}
          onLoadError={onLoadError}
        />
      }
    />
  );
}
